<template>
  <div class=''>
    <transition name="fade" mode="out-in">
      <button class="btn btn-metal" @click="onInvoiceClicked" v-if="showButton">
        Invoice
      </button>
      <div v-else>
        <form class="row" @submit.prevent="onGenerate">
          <v-select
            :options="months"
            placeholder="Select month"
            v-model="selectedMonth"
            class="mr-3"
            @input="fetchClients"
            @blur="$v.selectedMonth.touch()"
          ></v-select>
          <v-select
            placeholder="Select client"
            :disabled="!selectedMonth"
            :options="clients"
            label="name"
            v-model="selectedClient"
            @blur="$v.selectedClient.touch()"
          ></v-select>
          <button
            class="btn btn-metal ml-3"
            type="submit"
            :disabled="$v.$invalid">Generate
          </button>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import {required} from 'vuelidate/lib/validators'

  export default {
    components: {
      vSelect
    },
    validations: {
      selectedMonth: {
        required
      },
      selectedClient: {
        required
      }
    },
    data() {
      return {
        showButton: true,
        selectedMonth: null,
        selectedClient: null,
        months: [],
        clients: []
      }
    },

    created() {
      this.fillMonthsSelection()
    },

    methods: {
      onInvoiceClicked() {
        this.showButton = false
      },

      onGenerate() {

        const filename = moment().format('YYYY_MM_DD_HH_MM_SS') + '_' + this.selectedClient.name.toLowerCase().replace(/ /g, '_') + '.xls';

        const data = {
          startDate: this.selectedMonth.value,
          client_id: this.selectedClient.id,
          filename
        }

        this.axios.get('invoice/xls', {params: data, responseType: 'blob'})
          .then(res => {
            // close invoice generator
            this.showButton = true
            this.selectedMonth = null
            this.selectedClient = null

            // makes user to download file
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
          })
      },

      fillMonthsSelection() {
        for (let i in _.range(0, 12)) {
          const month = moment().subtract(i, 'months').startOf('month')

          this.months.push({
            label: month.format('MMMM, YYYY'),
            value: month.format('YYYY-MM-DD')
          })
        }
      },

      fetchClients() {
        if (!this.selectedMonth) {
          return
        }

        const data = {
          startDate: this.selectedMonth.value
        }

        this.axios.get('invoice/clients', {params: data})
          .then(res => {
            this.selectedClient = null
            this.clients = res.data.sort((a, b) => {
              if (a.name >= b.name)
                return 1;
              else
                return -1;
            })
          })
          .catch(error => {
          })
      }
    }
  }
</script>

<style>
  .container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 30px;
    flex-direction: row;
  }

  button[disabled] {
    cursor: not-allowed;
  }
</style>



// WEBPACK FOOTER //
// src/views/reports/InvoiceGenerator.vue